module.exports = __webpack_public_path__ + "img/cr.8f9e3dcc.svg";